import { clearLocalDatabase } from '../db/clear.ts';

/**
 * Wipes everything this device holds for the signed-out user.
 *
 * This is the H7 control from COMPLIANCE.md: without it, the next person to
 * sign in on a shared ward computer would see the previous trainee's logbook.
 *
 * It must never throw. A failure to clear local data cannot be allowed to
 * leave someone signed in — being stuck signed in is the worse outcome, and
 * the caller treats sign-out as final regardless.
 */
export async function clearLocalData(): Promise<void> {
  try {
    await clearLocalDatabase();
  } catch {
    // Nothing useful to do and nothing safe to log: the failure is on the way
    // out of a session, and the user is signed out either way.
  }
}
